import snarkdown from "snarkdown";

const htmlRegex = /<\/?[a-z][\s\S]*>/i;

function containsHtml(text: string) {
  return htmlRegex.test(text);
}

export function markdownToHtml(text: string) {
  if (!text?.length) return "";

  if (containsHtml(text)) {
    return text; // If already HTML, return it as-is
  }
  return snarkdown(text) as string;
}
